fragment CreatorUserFragment on User {
    id
    name
    avatarUrl
    initials
    firstName
    primaryEmailAddress
    teams {
        id
        name
    }
}
